import React, {useEffect, useState} from 'react';
import {Button, Col, Container, Row, Table} from 'react-bootstrap';

import {service as ActivityFeedSubscriptionService} from "../../../Services/ActivityFeedSubscriptionService";

import {Glyphicon} from "../../Common/GlyphIcon";
import {MutableList} from "../../Common/MutableList";

import {
    ArrayUtils,
    GuidUtils,
    ObjectUtils,
} from "../../../Utils";

import {useCheckAuth} from "../../../Hooks/RouteHooks";
import {useMakePageRequest} from "../../../Hooks/RequestHooks";

import {ContextNodeWithFullContextViewer} from "../../Common/ContextNodeWithFullContextViewer";

import {useContextIndependentPage} from "../../../Hooks/ContextBuilderHooks";
import {useClassNames} from "../../../Hooks/StyleHooks";

import {UserOrgContextNodeAutoSelect} from "../../Common/UserOrgContextNodeAutoSelect";
import {SubscriptionsPageRecord} from "./SubscriptionsPageRecord";
import {ActivityFeedFilterViewer} from "./ActivityFeedFilterViewer";


export const UsersSubscriptionsPage = props => {
    useCheckAuth();
    useContextIndependentPage(props);

    const classNames = useClassNames('sb-users-subscriptions-page');
    const makePageRequest = useMakePageRequest();

    const [subscriptions, setSubscriptions] = useState([]);
    const [editMode, setEditMode] = useState(false);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        makePageRequest(
            () => ActivityFeedSubscriptionService.GetActivityFeedSubscriptions(),
            (x) => {
                setSubscriptions(x.result);
                setEditMode(false);
            }
        );
    };

    const save = () => {
        let clone = ObjectUtils.Clone(subscriptions);

        clone.forEach((x) => {
            if(x._guid) {
                delete x._guid;
            }
        });

        makePageRequest(
            () => ActivityFeedSubscriptionService.UpdateActivityFeedSubscriptions(clone),
            () => setEditMode(false)
        );
    };

    const addSubscription = (contextNodeId) => {
        let clone = ObjectUtils.Clone(subscriptions);

        clone.push({
            contextNodeId: contextNodeId,
            _guid: GuidUtils.Generate()
        });

        setSubscriptions(clone);
    };

    const removeSubscription = (key) => {
        let clone = ObjectUtils.Clone(subscriptions);

        if(isNaN(key)) {
            clone = clone.filter((x) => !x._guid || x._guid != key);
        } else {
            clone = clone.filter((x) => x._guid || x.activityFeedSubscriptionId != key);
        }

        setSubscriptions(clone);
    };

    const updateSubscription = (key, value) => {
        let clone = ObjectUtils.Clone(subscriptions);
        let instance = null;

        if(isNaN(key)) {
            instance = clone.find((x) => x._guid && x._guid == key);
        } else {
            instance = clone.find((x) => !x._guid && x.activityFeedSubscriptionId == key);
        }

        if(instance) {
            instance.activityFeedFilterId = value;
        }

        setSubscriptions(clone);
    };

    const updateContextNode = (oldValue, newValue) => {
        let clone = ObjectUtils.Clone(subscriptions);

        clone.forEach((x) => {
            if(x.contextNodeId == oldValue) {
                x.contextNodeId = newValue;
            }
        });

        setSubscriptions(clone);
    };

    const addContextNode = () => {
        //only add subscription to null context node if we don't have one already.
        if(!subscriptions.some((x) => x.contextNodeId == null)) {
            addSubscription(null);
        }
    };

    let groups = ArrayUtils.GroupBy(
        [...subscriptions],
        (x) => x.contextNodeId,
        (a, b) => a.contextNodeId > b.contextNodeId
    );

    return <Container className={classNames}>
        <Row>
            <Col xs={12} md={12}>
                <h2 className="atomic-sectionheader">
                    <div className="float-right btn-edit">
                        {
                            editMode ?
                                [
                                    <Button
                                        variant="save"
                                        key={1}
                                        onClick={() => save()}
                                    >
                                        Save
                                    </Button>,
                                    <Button
                                        variant="cancel"
                                        key={2}
                                        onClick={() => loadData()}
                                    >
                                        Cancel
                                    </Button>
                                ]:
                                <Button
                                    className="link btn-link"
                                    key={1}
                                    onClick={() => setEditMode(true)}
                                >
                                    <Glyphicon glyph="pencil" />Edit
                                </Button>
                        }
                    </div>
                    Subscriptions
                </h2>
                <Table striped bordered size="sm" hover>
                    <tbody>
                    {
                        groups.map((x) =>
                            editMode ?
                                <tr key={x.key}>
                                    <td>
                                        <UserOrgContextNodeAutoSelect
                                            Value={x.key}
                                            OnUpdate={(y) => updateContextNode(x.key, y)}
                                        />
                                    </td>
                                    <td>
                                        <MutableList
                                            Data={x.value}
                                            Editable={true}
                                            Type={SubscriptionsPageRecord}
                                            AdditionalTypeProps={{}}
                                            AddItem={() => addSubscription(x.key)}
                                            UpdateItem={updateSubscription}
                                            RemoveItem={removeSubscription}
                                            GetItemKey={(x) => x.activityFeedSubscriptionId || x._guid}
                                        />
                                    </td>
                                </tr>:
                                <tr key={x.key}>
                                    <td>
                                        <ContextNodeWithFullContextViewer ContextNodeId={x.key} />
                                    </td>
                                    <td>
                                        <div className="sb-activity-feed-filter-list">
                                            {
                                                x.value.map((y) =>
                                                    <ActivityFeedFilterViewer
                                                        key={y.activityFeedFilterId}
                                                        ActivityFeedFilterId={y.activityFeedFilterId}
                                                    />
                                                )
                                            }
                                        </div>
                                    </td>
                                </tr>
                        )
                    }
                    </tbody>
                </Table>
            </Col>
            <Col xs={12} md={12}>
                {
                    editMode ?
                        <a className="float-right" onClick={addContextNode}>
                            <Glyphicon glyph="plus-sign" />Add Program/Project
                        </a>:
                        null
                }
            </Col>
        </Row>
    </Container>;
};


